<template>
  <div v-loading="loading"
       class="social-myFeed-main">
    <div class="social-top-filter">
      <el-pagination :page-size="pagination.pageSize"
                     :current-page="pagination.currentPage"
                     :layout="paginationOptions.layout"
                     :page-sizes="paginationOptions.pageSizes"
                     :total="myFeedMeta.total"
                     @prev-click="handlePrevNext"
                     @next-click="handlePrevNext"
                     @size-change="handleSizeChange">
        <span class="el-pagination__custom-current-page">
          {{ $t('Page') }} {{ pagination.currentPage }}
        </span>
      </el-pagination>
      <el-select v-model="value"
                 class="options-filter"
                 placeholder="Select">
        <el-option
          v-for="item in optionsFilter"
          :key="item.value"
          :label="$t(item.label)"
          :value="item.value" />
      </el-select>
    </div>
    <div class="social-cards-wrapper">
      <el-card v-for="(item, index) in socialMyFeedData"
               :key="index"
               class="social-box"
               :body-style="{ padding: '0px' }">
        <div class="social-myFeed-img-box">
          <router-link
            :to="{ name: Breadcrumbs.visitsDetail, params: { visitId: item.id, imgExp: true } }">
            <div class="content_img">
              <img :src="item.file_url"
                   :alt="item.store.display_name"
                   width="191px"
                   height="217px">
              <div class="hover-title" style="text-transform: uppercase;">
                {{ $t('View Visit') }}
              </div>
            </div>
            <div class="social-myFeed-icons">
              <div class="likesCount">
                <i class="mdi mdi-thumb-up" />
                <span> {{ item.social.likes }} </span>
              </div>
              <div class="commentsCount">
                <i class="mdi mdi-comment" />
                <span> {{ item.social.comments }} </span>
              </div>
            </div>
          </router-link>
        </div>
        <div class="social-MyFeed-info">
          <div :title="item.store.display_name"
               class="storeName">
            <el-tooltip class="item"
                        effect="dark"
                        :content="item.store.display_name"
                        placement="top">
              <span class="store-name-text">
                {{ item.store.display_name }}
              </span>
            </el-tooltip>
          </div>
          <div class="visitDate">
            {{ chatDate(item.started_at) }}
          </div>
          <div class="auditor">
            {{ item.auditor.code }}
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { chain, pick } from 'lodash';
import i18n from '@/i18n';
import { fetchMyFeed, fetchMyFeedVisit, fetchTopScores } from '../api';
import BackendPaginationMixin from '../../../helpers/mixins/backendPagination';
import WorkWithDashboardFilter from '../../../helpers/mixins/workWithDashboardFilter';

export default {
  name: 'MyFeed',
  mixins: [BackendPaginationMixin, WorkWithDashboardFilter],
  props: {
    projectId: {
      type: [String, Number],
      default: ''
    },
    topScores: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    return {
      myFeedData: [],
      socialMyFeedData: [],
      myFeedDataVisit: [],
      myFeedMeta: [],
      pagination: {
        pageSize: 20
      },
      paginationOptions: {
        pageSizes: [20]
      },
      optionsFilter: [{
        value: 'like',
        label: 'Likes'
      }, {
        value: 'comment',
        label: 'Comments'
      }, {
        value: 'started_at',
        label: 'Date'
      }],
      value: 'like'
    };
  },
  watch: {
    socialMyFeedData(x) {
      this.socialMyFeedData = x;
    },
    value(selected) {
      this.fetchData(selected);
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData(selected) {
      const { projectId } = this;
      const { selectedFilterScopes, start_time: clientStartTime, end_time: clientEndTime } = this.GlobalFilters.query;
      const start_date_with_time = this.convertToServerTimeZone(`${clientStartTime} 00:00:00`);
      const end_date_with_time = this.convertToServerTimeZone(`${clientEndTime} 23:59:59`);
      const params = {
        ...this.getQuery,
        filter: {
          project: projectId,
          start_date_with_time,
          end_date_with_time,
          ...selectedFilterScopes
        }
      };

      if (selected !== undefined) {
        params.sort = selected;
      } else {
        params.sort = 'like';
      }

      try {
        this.loading = true;
        if (this.topScores) {
          const { data: { data, meta } } = await fetchTopScores(projectId, params);
          this.myFeedData = data;
          this.myFeedMeta = meta;
          this.fetchMyFeedVisit(data);
        } else {
          const { data: { data, meta } } = await fetchMyFeed(projectId, params);
          this.myFeedData = data;
          this.myFeedMeta = meta;
          this.fetchMyFeedVisit(data);
        }
      } catch (err) {
        console.warn(err);
      }
    },
    async fetchMyFeedVisit(item) {
      const { projectId } = this;
      this.myFeedDataVisit = [];
      try {
        for (let i = 0; i < item.length; i++) {
          // eslint-disable-next-line no-await-in-loop
          const resp = await fetchMyFeedVisit(projectId, item[i].id);
          this.myFeedDataVisit.push(resp.data);
        }

        this.socialMyFeedData = chain(this.myFeedData).map((el, index) => ({
          ...el,
          ...pick(this.myFeedDataVisit[index], ['file_url'])
        })).value();
      } catch (err) {
        console.warn(err);
      }
      this.loading = false;
    },
    chatDate(date) {
      moment.locale(i18n.locale);
      const startDate = moment().startOf().format('DD/MM/YYYY');
      const endDate = moment(date).format('DD/MM/YYYY');

      if (startDate === endDate) {
        return moment(date).fromNow();
      }

      return moment(date).format('DD/MM/YYYY');
    }
  }
};
</script>

<style lang="scss">
.social-myFeed-main {
  padding: 20px;
  margin-right: 20px;
  background-color: #fff;
  border-radius: 3px;

  .social-top-filter {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .options-filter {
      width: 145px;

      .el-input {
        &__inner {
          font-weight: 600;
          color: #4a90e2;
          border: 1px solid #4a90e2;
        }

        &__suffix {
          &-inner {
            .el-select__caret {
              font-size: 16px;
              font-weight: 600;
              color: #4a90e2;
            }
          }
        }
      }
    }
  }

  .social-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    max-height: 1030px;
    margin-top: 8px;
    overflow: scroll;
  }

  .social-box {
    margin: 7px;
    box-shadow: 0 0 0 0 !important;
  }

  .social-myFeed-img-box {
    .content_img {
      position: relative;
    }

    .content_img .hover-title {
      position: absolute;
      right: 0;
      bottom: 0;
      margin-bottom: 5px;
      font-family: sans-serif;
      color: white;
      visibility: hidden;
      background: $darkSkyBlue;
      opacity: 0;
      -webkit-transition: visibility 0s, opacity 0.5s linear;
      transition: visibility 0s, opacity 0.5s linear;

      @include breakpoint(md-max) {
        width: 105px !important;
        height: 120px !important;
        font-size: 12px;
      }
    }

    .content_img:hover .hover-title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 191px;
      height: 217px;
      visibility: visible;
      opacity: 0.7;
    }
  }
}

.social-myFeed-icons {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 191px;
  height: 43px;
  margin-top: -5px;
  font-size: 25px;
  color: $white;
  background-color: $darkSkyBlue;
}

.social-MyFeed-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 191px;
  margin-top: 5px;
  text-align: center;

  .auditor,
  .storeName {
    font-weight: bold;
  }

  .auditor {
    margin-top: 10px;
  }

  .storeName {
    .store-name-text {
      display: -webkit-box;
      height: 45px;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;

      @include breakpoint(md-max) {
        height: 35px;
      }
    }
  }

  .visitDate {
    color: #2a2f3a;
    opacity: 0.5;
  }
}

@include breakpoint(md-max) {
  .social-myFeed-main {
    display: flex;
    flex-direction: column;
    width: unset;
    max-height: unset;
    padding: 0;
    margin-right: unset;
    margin-bottom: 20px;

    .social-top-filter {
      flex-direction: column;
      width: unset;
      height: 70px;
      margin: 10px;

      .options-filter {
        width: 100%;
      }
    }
  }

  .content_img:hover {
    opacity: 0.7;
  }

  .social-box {
    margin: 5px !important;

    .content_img img {
      width: 105px !important;
      height: 120px !important;
    }

    .social-myFeed-icons {
      width: 105px;
      height: 25px;

      .commentsCount,
      .likesCount {
        font-size: 16px;
      }
    }

    .social-MyFeed-info {
      width: 105px;
      margin-bottom: 10px;

      .storeName,
      .visitDate,
      .auditor {
        font-size: 12px;
      }
    }
  }
}

@media (min-width: 1024px) {
  .social-myFeed-main {
    max-width: 92%;
  }
}
</style>
